import { render, staticRenderFns } from "./AiChatTest.vue?vue&type=template&id=c262e2e6&scoped=true"
import script from "./AiChatTest.vue?vue&type=script&lang=js"
export * from "./AiChatTest.vue?vue&type=script&lang=js"
import style0 from "./AiChatTest.vue?vue&type=style&index=0&id=c262e2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c262e2e6",
  null
  
)

export default component.exports